import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { ThemeContext } from '../../contexts/ThemeContext';
import { LanguageContext } from '../../contexts/LanguageContext'; // Importer le LanguageContext
import { projectsData } from '../../data/projectsData';

import './Project2.css';
import SingleProject2 from './SingleProject/SingleProject2';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

function Project2() {
  const { theme } = useContext(ThemeContext);
  const { language } = useContext(LanguageContext); // Récupérer la langue actuelle

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    gsap.fromTo(
      '.projects--header',
      {
        opacity: 0,
        scale: 0.5,
      },
      {
        opacity: 1,
        scale: 1,
        duration: 1,
        y: 50,
        scrollTrigger: {
          trigger: '.projects--header h1',
          start: 'top 95%',
          end: 'top 30%',
          scrub: 1,
          ease: 'power1.inOut',
        },
      }
    );
  }, []);

  return (
    <div>
      {projectsData.length > 0 && (
        <div className="projects" id="projects">
          <div className="projects--header">
            <h1 style={{ color: theme.primary }}>
              {language === 'en' ? 'Projects' : 'Projets'} {/* Affichage dynamique du titre */}
            </h1>
          </div>
          <div className="projects--body">
            <div className="projects--bodyContainer">
              {projectsData.map(project => (
                <SingleProject2
                  theme={theme}
                  key={project.id}
                  id={project.id}
                  name={project.projectName[language]} 
                  desc={project.projectDesc[language]} 
                  tags={project.tags}
                  code={project.code}
                  demo={project.demo}
                  image={project.image}
                  device={project.device}
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Project2;
